import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { FormsModule} from '@angular/forms';
import { Routes, RouterModule }  from '@angular/router';

import {Blogcategory} from "./blogcategory.page";

export const routes: Routes = [
    { path: 'blogcategory', component: Blogcategory }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        Blogcategory
    ]
})

export class BlogcategoryModule { }



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/blogcategory/blogcategory.module.ts